import { useAuthContext } from '@providers/AuthProvider';

import { useModalContext } from '@providers/ModalProvider';
import { ModalNamesEnum } from '@constants/enums/ModalNamesEnum';

import BG from './images/banner_bg.png';
import { Wrapper } from './styles/Wrapper';
import type { PlanSelection } from '@pages/User/BillingAccountDetailsPage/components/SubscriptionsWrapper/AddSubscription';

export const YearEndSpecial = () => {
  const { openModal, closeModal } = useModalContext();
  const { organization } = useAuthContext();

  const canSelectSubscription =
    organization?.billingAccount && organization?.permissions?.viewBilling && organization?.permissions?.manageBilling;

  const orgHasSubscription = !!organization?.billingAccount?.activeSubscriptionId;

  const openSubscriptionsModal = () => {
    if (orgHasSubscription) {
      return;
    }

    if (!canSelectSubscription) {
      return;
    }
    openModal(ModalNamesEnum.ChooseASOneSubscriptionModal, {
      billingAccountId: organization.billingAccount?.id,
      onSuccess: ({ subscriptionProductId, planName, price, freeSeats }: PlanSelection) => {
        closeModal();

        openModal(ModalNamesEnum.ConfirmSubscription, {
          billingAccountId: organization.billingAccount?.id,
          subscriptionProductId,
          planName,
          freeSeats,
          price: Number(price),
        });
      },
    });
  };

  return (
    <Wrapper
      className={canSelectSubscription && !orgHasSubscription ? 'clickable' : ''}
      onClick={openSubscriptionsModal}
    >
      <img src={BG} width="auto" height="auto" alt="" />
      <div className="flex">
        <div className="title">AutoScriptOne is Now Live!</div>
        <div className="subtitle">
          Capture & Edit Proceedings in Real-time with the
          <br />
          Industry&apos;s Most Powerful AI Reporting Platform.
        </div>
      </div>
      <div className="third" />
      {canSelectSubscription && !orgHasSubscription ? <button type="button">Learn More</button> : null}
    </Wrapper>
  );
};
